// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Placeholder for the carousel instances.
     *
     * @method block.instances
     */
    instances: [],

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all tab blocks on the page
      ui.blocks = doms(".block.carousel");

      // Iterate over the blocks to bind to each
      for (var index = 0; index < ui.blocks.length; index++) {
        block.instances.push(new Carousel(ui.blocks[index], "carousel"));
      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
